import BaseService from '@core/common/BaseService';
import { MsgHistoryClient, RESOURCES } from '@core/clients/MsgHistoryClient';
import {
  transformConversationsHistoryRequest,
  transformConversationsHistoryResponse,
  transformConversationParticipantsRequest,
  transformConversationParticipantsResponse,
  participantsReducer,
} from './conversationsHistoryTransformer';

const SETTINGS = {
  DEFAULT_BRAND_KEY: 'default',
  CONVERSATION_HISTORY_DEFAULTS: {
    offset: 0,
    limit: 100,
  },
};


class ConversationsHistoryService extends BaseService {
  constructor() {
    super({ name: 'ConversationsHistoryService' });
    this.client = null;
  }

  /**
   * Set MsgHistoryClient with params
   * @param brandId
   */
  setClientWithParams(brandId) {
    if (!this.client) {
      const clientParams = {
        resource: RESOURCES.SEARCH_CONVERSATIONS_DATA,
      };

      if (brandId && brandId !== SETTINGS.DEFAULT_BRAND_KEY) {
        clientParams.brandId = brandId;
      }

      this.client = new MsgHistoryClient(clientParams);
    }
  }

  async getConversationsHistory(params) {
    const {
      brandId,
      conversationId,
      consumerId,
      offset = SETTINGS.CONVERSATION_HISTORY_DEFAULTS.offset,
      limit = SETTINGS.CONVERSATION_HISTORY_DEFAULTS.limit,
    } = params;
    this.setClientWithParams(brandId);
    //
    const requestSettings = transformConversationsHistoryRequest({
      conversationId,
      offset,
      limit,
    });
    try {
      let response = await this.sendClientRequest(
        this.client,
        requestSettings,
        `Couldn't conversation info. consumerId: ${consumerId} , brandId: ${brandId}`,
      );
      response = transformConversationsHistoryResponse(response);
      return response;
    } catch (e) {
      this.logError(`Error fetching conversation info: ${e}, conversationId: ${conversationId} , brandId: ${brandId}`);
      return {};
    }
  }

  /**
   * @param params
   * @param params.brandId
   * @param params.conversationId
   * @param params.consumerId
   * @return {Promise<{}>}
   */
  async getConversationParticipants(params) {
    const { brandId, conversationId, consumerId } = params;
    this.setClientWithParams(brandId);
    const requestSettings = transformConversationParticipantsRequest({ conversationId });
    try {
      let response = await this.sendClientRequest(
        this.client,
        requestSettings,
        `Couldn't fetch participants info: conversationId: ${conversationId}`,
      );
      // transform response with passing down the reducer <participantsReducer>
      // as a curried function with <brandId> as a first argument
      response = transformConversationParticipantsResponse(response, participantsReducer(brandId));
      return response;
    } catch (e) {
      this.logError(`Error fetching consumer info: ${e}, consumerId: ${consumerId} , brandId: ${brandId}`);
      return {};
    }
  }
}

const conversationsHistoryService = new ConversationsHistoryService();

export default conversationsHistoryService;
